var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTy03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600.000000pt",
    height: "600.000000pt",
    viewBox: "0 0 600.000000 600.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,600.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1929 5103 c0 -5 0 -675 1 -1490 l2 -1483 -649 -2 -648 -3 0 -608 0 -608 1990 1 c1095 0 2020 3 2058 7 l67 6 -2 606 -3 606 -647 3 -648 2 -2 1483 -3 1482 -757 3 c-417 1 -758 -1 -759 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4488 4429 c-144 -15 -337 -97 -382 -160 -21 -30 -23 -161 -2 -178 16 -14 32 -8 111 39 277 168 547 127 606 -93 30 -114 -13 -254 -102 -329 -74 -63 -140 -81 -316 -87 -105 -4 -156 -10 -165 -19 -18 -18 -17 -134 1 -155 11 -14 33 -17 120 -17 280 0 438 -53 518 -173 84 -126 56 -323 -59 -410 -153 -117 -404 -109 -661 20 -90 45 -110 42 -118 -17 -10 -64 6 -141 34 -164 36 -31 119 -65 224 -92 82 -22 120 -26 238 -26 225 0 372 49 489 166 109 107 151 224 144 395 -3 77 -9 107 -30 154 -55 118 -172 209 -320 246 -70 18 -71 19 -38 26 178 38 310 222 310 429 0 312 -235 485 -602 445z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTy03);
export default __webpack_public_path__ + "static/media/TY03.d9c49ded0e7491a996bfea7b6bccbcfa.svg";
export { ForwardRef as ReactComponent };